import React from "react";
import { Title, Field, Control, Label, Input, Column } from "rbx";
import PropTypes from "prop-types";
import HorizontalRule from "../../../../styles/HorizontalRule";
import {
  SystemCodeSelect,
  DateInput,
  LocationSelect,
  StateSelect
} from "../../../../components/inputs";

const DriversAndMechanics = ({
  employee,
  editing,
  onChange,
  mechanicTypeRecIdRef,
  MechanicAuth,
  isDispatcher
}) => (
  <div>
    <HorizontalRule />
    <Title size={4}>Drivers &amp; Mechanics</Title>
    <Column.Group>
      <Column size={2}>
        <Field>
          <Control>
            <LocationSelect
              icon="globe"
              label="Home Terminal"
              name="HomeCompanyLocationId"
              readOnly={!editing || !employee.DriverFlag}
              value={employee.HomeCompanyLocationId}
              onChange={onChange}
            />
          </Control>
        </Field>
      </Column>
      {employee.DriverFlag && (
        <React.Fragment>
          <Column size={1}>
            <Field>
              <Control>
                <Label>License #</Label>
                <Input
                  autocomplete="new"
                  disabled={!editing || !employee.DriverFlag}
                  name="DriverLicenseNo"
                  type="text"
                  value={employee.DriverLicenseNo}
                  onChange={onChange}
                />
              </Control>
            </Field>
          </Column>
          <Column size={1.5}>
            <Field>
              <Control>
                <Label>License State</Label>
                <StateSelect
                  disabled={!editing || !employee.DriverFlag}
                  name="DriverLicenseState"
                  value={employee.DriverLicenseState}
                  onChange={onChange}
                />
              </Control>
            </Field>
          </Column>
        </React.Fragment>
      )}
      <Column narrow>
        <Field>
          <Control>
            <Label>Seniority Date</Label>
            <DateInput
              name="SeniorityDate"
              readOnly={
                (!editing || !employee.DriverFlag) &&
                parseInt(employee.EmployeeTypeRecIdRef) !== mechanicTypeRecIdRef
              }
              value={employee.SeniorityDate}
              onChange={onChange}
            />
          </Control>
        </Field>
      </Column>
      <Column size={1}>
        <Field>
          <Control>
            <Label>Seniority #</Label>
            <Input
              autocomplete="new"
              name="SeniorityNo"
              readOnly={
                (!editing || !employee.DriverFlag) &&
                parseInt(employee.EmployeeTypeRecIdRef, 10) !==
                  mechanicTypeRecIdRef
              }
              type="text"
              value={employee.SeniorityNo}
              onChange={onChange}
            />
          </Control>
        </Field>
      </Column>
      <Column size={1}>
        <Field>
          <Control>
            <Label>Weight</Label>
            <Input
              autocomplete="new"
              name="Weight"
              readOnly={!editing || !employee.DriverFlag}
              type="text"
              value={employee.Weight}
              onChange={onChange}
            />
          </Control>
        </Field>
      </Column>
      {!isDispatcher && (
        <React.Fragment>
          <Column size={1}>
            <Field>
              <Control>
                <Label>WO Labor Rate</Label>
                <Input
                  autoComplete="new"
                  defaultValue="$0.00"
                  disabled={!editing || !MechanicAuth}
                  name="HourlyRate"
                  type="text"
                  value={employee.HourlyRate}
                  onChange={onChange}
                />
              </Control>
            </Field>
          </Column>
        </React.Fragment>
      )}

      <Column narrow>
        <Field>
          <Control>
            <Label>Last Worked Date</Label>
            <DateInput
              name="LastWorkedDate"
              readOnly={!editing || !employee.DriverFlag}
              value={employee?.LastWorkedDate}
              onChange={onChange}
            />
          </Control>
        </Field>
      </Column>
      {employee.DriverFlag && (
        <Column size={2}>
          <Control expanded>
            <SystemCodeSelect
              required
              icon="globe"
              label="ELD Status"
              lookup={{ Category: "ELD", Code: "ELDStatus" }}
              name="ELDStatusRecIdRef"
              readOnly={!editing}
              value={employee.ELDStatusRecIdRef}
              onChange={onChange}
            />
          </Control>
        </Column>
      )}
    </Column.Group>
  </div>
);

DriversAndMechanics.propTypes = {
  onChange: PropTypes.func,
  employee: PropTypes.object,
  editing: PropTypes.bool,
  mechanicTypeRecIdRef: PropTypes.number,
  MechanicAuth: PropTypes.bool,
  isDispatcher: PropTypes.bool
};
DriversAndMechanics.defaultProps = {
  employee: {}
};
export default DriversAndMechanics;
